import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import TopNavBar from '../components/navigation/TopNavBar'
import SectionHeaderView from '../components/views/SectionHeaderView'
import DropdownInput from '../components/inputs/DropdownInput'
import RoundedButton from '../components/buttons/RoundedButton'
import LoadingModal from '../components/modals/LoadingModal'
import * as Constants from '../utils/constants'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import newSchedule from '../assets/new-schedule.png'
import arrow from '../assets/arrow.png'
import strings from '../res/strings'
import 'react-toastify/dist/ReactToastify.css'

const NewSchedule = () => {
    const { state } = useLocation()
    let service = null
    let boat = null
    let harbor = null

    if (state) {
        ( { service, boat, harbor } = state)
    }

    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedBoat, setSelectedBoat] = useState(null)
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [selectedInterventionType, setSelectedInterventionType] = useState(null)

    const [harbors, setHarbors] = useState([])
    const [boats, setBoats] = useState([])
    const [interventionTypes, setInterventionTypes] = useState([])
    const [harborInterventionTypes, setHarborInterventionTypes] = useState([])
    const [clients, setClients] = useState([])

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else {
                getHarbors()
                getInterventionTypes()

                if(loggedUser.role === Constants.Roles.CLIENT) {
                    getBoats()
                } else {
                    getClients() 
                }
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    // Handle get user harbor request
    const getUserHarbor = (arrayInterventionTypes) => {
        fetch('/api/Backoffice/GetHarbor', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                const harbor = {
                    value: jsonRes.harborId,
                    label: jsonRes.harborName
                }

                setSelectedLocation(harbor)
                
                getHarborInterventionTypes(jsonRes.harborId, arrayInterventionTypes)
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getUserHarborError)

                    setSelectedLocation(null)
                }, 1000)
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setSelectedLocation(null)
            }, 1000)
        })
    }

    // Handle get harbors request
    const getHarbors = () => {
        fetch('/api/Boat/Dropdowns', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                const arrayHarbors = jsonRes.harbors.map((option) => ({ value: option.id, label: option.name }))
                setHarbors(arrayHarbors)

                setSelectedLocation(harbor ? arrayHarbors.find(harborItem => harborItem.value === harbor) : null)

                if(harbor) {
                    getAdminHarborInterventionTypes(harbor)
                }
            } else {
                setTimeout(() => {
                    setIsLoading(false)
                    showErrorToast(strings.getDropdownsError)

                    setHarbors([])
                }, 1000)   
            }
    
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setHarbors([])
            }, 1000)
        })
    }

    // Handle get intervetion types request
    const getInterventionTypes = () => {
        fetch('/api/Schedule/Types', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            if (response.status === 200) {
                const jsonRes = await response.json()

                const arrayInterventionTypes = jsonRes.map((option) => ({ value: option.id, label: option.name }))
                setInterventionTypes(arrayInterventionTypes)

                setSelectedInterventionType(service ? arrayInterventionTypes.find(interventionType => interventionType.value === service) : null)

                if(loggedUser.role === Constants.Roles.PORTADMIN || loggedUser.role === Constants.Roles.PORTTECHNICIAN || loggedUser.role === Constants.Roles.DEALER) {
                    getUserHarbor(arrayInterventionTypes)
                }

            } else {
                showErrorToast(strings.getIntervetionTypesError)
                setInterventionTypes([])
            }

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setInterventionTypes([])
            }, 1000)
        })
    }

    // Handle get boats request
    const getBoats = () => {
        fetch('/api/Boat/List', {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()
                  
                    const arrayBoats = jsonRes.map((option) => ({ value: option.id, label: option.name }))
                    setBoats(arrayBoats)

                    setSelectedBoat(boat ? arrayBoats.find(itemBoat => itemBoat.value === boat) : null)
                } else {
                    setTimeout(() => {
                        setIsLoading(false)
                        showErrorToast(strings.getBoatsError)
                        
                        setBoats([])
                    }, 1000)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
                
                setBoats([])
            }, 1000)
        })
    }

    // Handle get clients request
    const getClients = () => {
        fetch(`/api/Backoffice/List?roleId=${Constants.Roles.CLIENT}`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()

                    let clients = []
    
                    jsonRes.map(client => {
                        if(client.active && !client.isDeleted) {
                            clients.push(client)
                        }
                    })

                    const arrayClients = clients.map((option) => ({ value: option.id, label: option.name }))

                    setClients(arrayClients)
                } else {
                    setClients([])
                    showErrorToast(strings.getUsersError + strings.client)
                }
            }, 1000)
 
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setClients([])
            }, 1000) 
        })
    }

    // Handle get client boats
    const getClientBoats = (id) => {
        setIsLoading(true)

        fetch(`/api/Backoffice/${id}/GetClientBoats`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()

                    const arrayBoats = jsonRes.map((option) => ({ value: option.id, label: option.name }))
                    setBoats(arrayBoats)
                } else {
                    showErrorToast(strings.getClientBoatsError)
                    setBoats([])
                }
                
            }, 1000)
    
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setBoats([])
            }, 1000)
        })
    }

    // Handle get harbor intervention types (Admin IT)
    const getAdminHarborInterventionTypes = (id) => {
        setIsLoading(true)

        fetch(`/api/Schedule/${id}/Types`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()

                    const arrayHarborInterventionTypes = jsonRes.map((option) => ({ value: option.id, label: option.name }))
                    setHarborInterventionTypes(arrayHarborInterventionTypes)
                } else {
                    showErrorToast(strings.getHarborInterventionTypesError)
                    setHarborInterventionTypes([])
                }
                
            }, 1000)
    
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setHarborInterventionTypes([])
            }, 1000)
        })
    }

    // Handle get harbor intervention types
    const getHarborInterventionTypes = (harborId, arrayInterventionTypes) => {
        setIsLoading(true)

        fetch(`/api/Backoffice/${harborId}/${loggedUser.entityId}/GetScheduleTypesByHarborAndEntity`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)

                if (response.status === 200) {
                    const jsonRes = await response.json()

                    let services = []
                    
                    jsonRes.map((skill) => {
                        arrayInterventionTypes.map((interventionType) => {
                            if(skill.name === interventionType.label) {
                                services.push({
                                    value: interventionType.value,
                                    label: interventionType.label
                                })
                            }

                        })
                    })

                    setHarborInterventionTypes(services)

                    setSelectedInterventionType(service ? services.find(interventionType => interventionType.value === service) : null)
                } else {
                    showErrorToast(strings.getHarborInterventionTypesError)
                    setHarborInterventionTypes([])
                }
                
            }, 1000)
    
        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setHarborInterventionTypes([])
            }, 1000)
        })
    }

    // Handle changes in location dropdown input
    const onChangeSelectedLocation = (item) => {
        setSelectedLocation(item)
        setSelectedInterventionType(null)
        
        if(loggedUser.role === Constants.Roles.ADMINIT || loggedUser.role === Constants.Roles.CLIENT) {
            getAdminHarborInterventionTypes(item.value)
        } else {
            getHarborInterventionTypes(item.value, interventionTypes)
        }
    }

    // Navigates to next step
    const goToNextStep = () => {
        if(selectedInterventionType.value === Constants.ScheduleTypes.FAIRING || selectedInterventionType.value === Constants.ScheduleTypes.FAIRINGENERGY) {
            navigate('/new-schedule-fairing', {
                state: {
                    schedule: {
                        boatId: selectedBoat.value,
                        harborId: selectedLocation.value,
                        scheduleTypeId: selectedInterventionType.value,
                        userId: selectedUser ? selectedUser.value : null
                    },
                    electricitySupply: selectedInterventionType.value === Constants.ScheduleTypes.FAIRING ? false : true
                }}
            )

        } else if(selectedInterventionType.value === Constants.ScheduleTypes.MOORING || selectedInterventionType.value === Constants.ScheduleTypes.MOORINGENERGY){
            navigate('/new-schedule-mooring', {
                state: {
                    schedule: {
                        boatId: selectedBoat.value,
                        harborId: selectedLocation.value,
                        scheduleTypeId: selectedInterventionType.value,
                        userId: selectedUser ? selectedUser.value : null
                    },
                    electricitySupply: selectedInterventionType.value === Constants.ScheduleTypes.MOORING ? false : true
                }}
            )

        } else if(selectedInterventionType.value === Constants.ScheduleTypes.FACILITIES) {
            navigate('/new-schedule-facilities', {
                state: {
                    schedule: {
                        boatId: selectedBoat.value,
                        harborId: selectedLocation.value,
                        scheduleTypeId: selectedInterventionType.value,
                        userId: selectedUser ? selectedUser.value : null
                    }
                }}
            )

        } else {
            navigate('/new-schedule-electricity-supply', {
                state: {
                    schedule: {
                        boatId: selectedBoat.value,
                        harborId: selectedLocation.value,
                        scheduleTypeId: selectedInterventionType.value,
                        userId: selectedUser ? selectedUser.value : null
                    }
                }}
            )
        }
    }

    // Check if all fields are not empty so the user can click 'Next' button
    const allFieldsValid = () => {
        if(loggedUser && loggedUser.role !== Constants.Roles.CLIENT) {
            if(selectedUser && selectedBoat && selectedLocation && selectedInterventionType) {
                return true
            } else {
                return false
            }
        } else {
            if(selectedBoat && selectedLocation && selectedInterventionType) {
                return true
            } else {
                return false
            }
        } 
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <>
            <TopNavBar />

            { isLoading ?
                <div className='h-screen'>
                    <LoadingModal />
                </div>
            :   <div className='flex flex-row'>

                    <div className='flex flex-col flex-1'> 

                        <div className='flex flex-row items-center mt-16 mb-10 px-[3.5rem] space-x-2'>
                            <Link to='/'>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </Link>
                            <p className='font-montserrat font-semibold text-accent'>{strings.newSchedule}</p>
                        </div>

                        <div className='px-[3.5rem]'>
                            <SectionHeaderView 
                                text={strings.info}
                                margin={16}
                            />
                        </div>

                        <div className='flex flex-1 flex-col mt-4 px-[3.5rem]'>
                            { loggedUser && loggedUser.role !== Constants.Roles.CLIENT ?
                                <div className='mb-9'>
                                    <p className='font-montserrat font-semibold text-sm'>{strings.user}</p>
                                    <DropdownInput 
                                        options={clients}
                                        value={selectedUser}
                                        onChange={(item) => {setSelectedUser(item); getClientBoats(item.value)}}
                                    />
                                </div>
                            : null }
                            
                            <p className='font-montserrat font-semibold text-sm'>{strings.boatToIntervene}</p>
                            <DropdownInput 
                                options={boats}
                                value={selectedBoat}
                                onChange={(item) => setSelectedBoat(item)}
                                disabled={loggedUser && (loggedUser.role === Constants.Roles.CLIENT) ? false : selectedUser ? false : true}
                            />

                            <p className='font-montserrat font-semibold text-sm mt-9'>{strings.interventionLocal}</p>
                            <DropdownInput 
                                options={harbors}
                                value={selectedLocation}
                                onChange={onChangeSelectedLocation}
                                disabled={loggedUser && (loggedUser.role === Constants.Roles.PORTTECHNICIAN || loggedUser.role === Constants.Roles.PORTADMIN || loggedUser.role === Constants.Roles.DEALER ? true : false)}
                            />

                            <p className='font-montserrat font-semibold text-sm mt-9'>{strings.interventionType}</p>
                            <DropdownInput 
                                options={harborInterventionTypes ? harborInterventionTypes : interventionTypes}
                                value={selectedInterventionType}
                                onChange={(item) => setSelectedInterventionType(item)}
                                disabled={selectedLocation ? false : true}
                            />

                            <div className='flex flex-row items-center mt-9 space-x-6'>
                                <div className='flex w-[16.25rem]'>
                                    <RoundedButton
                                        onClick={() => navigate('/')}
                                        text={strings.cancel}
                                        height={48}
                                        bgColor='#E85F5C'
                                    />
                                </div>

                                <div className='flex w-[16.25rem]'>
                                    <RoundedButton
                                        onClick={goToNextStep}
                                        text={strings.next}
                                        height={48}
                                        bgColor='#007EB4'
                                        disabled={allFieldsValid() ? false : true}
                                    />
                                </div>
                            
                            </div>
                        </div>
                        
                    </div>

                    <div className='flex flex-1'>
                        <img className='min-h-screen object-cover' src={newSchedule} alt='Novo Agendamento'/>
                    </div>
                </div>
            }

            <ToastContainer />
        </>
    )
}

export default NewSchedule